import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import Terminal from "../components/terminal"
import SEO from "../components/seo"
import { rhythm, scale } from "../utils/typography"

class BlogPostTemplate extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      termStartState: 'maximised',
      termClassName: ''
    }
  }

  componentDidMount () {
    if (window.innerHeight < 450) {
      this.setState({
        termStartState: 'minimised',
        termClassName: "is-minimized"
      })
    }
  }
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = this.props.data.site.siteMetadata.title
    const { previous, next } = this.props.pageContext
    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.frontmatter.title}
          description={post.frontmatter.description || post.excerpt}
        />
        <article id="post-article">
          <header>
            <h1
              style={{
                marginTop: rhythm(1),
                marginBottom: 0,
              }}
            >
              {post.frontmatter.title}
            </h1>
            <p
              style={{
                ...scale(-1 / 5),
                display: `block`,
                marginBottom: rhythm(1),
              }}
            >
              {post.frontmatter.date}
            </p>
          </header>
          <section dangerouslySetInnerHTML={{ __html: post.html }} />
        </article>
        <div id="terminal-wrapper" className={this.state.termClassName}>
          <Terminal
            postSlug={this.props.data.markdownRemark.fields.slug}
            actionHandlers={{
              handleMaximise: (toggleMaximise) => {
                document.getElementById('terminal-wrapper').classList.remove('is-minimized');
                document.getElementById('terminal-wrapper').classList.toggle('is-maximized');
                toggleMaximise()
              },
              handleMinimise: (toggleMinimise) => {
                document.getElementById('terminal-wrapper').classList.remove('is-maximized');
                document.getElementById('terminal-wrapper').classList.toggle('is-minimized');
                toggleMinimise();
              },
              handleClose: (doClose) => {
                document.getElementById('old-school-wrapper').style.display = 'block'
                let term = document.getElementById('terminal-wrapper')
                term.style.height = '50px'
                term.style.position = 'relative'
                document.getElementById('post-article').style.marginBottom = 0
                doClose()
              }
            }}
            startState={this.state.termStartState}
            msg={"== " + post.frontmatter.title + " =="}
          />
        </div>
        <div id="old-school-wrapper" style={{display: 'none'}}>
          {
          <nav>
            <ul
              style={{
                display: `flex`,
                flexWrap: `wrap`,
                justifyContent: `space-between`,
                listStyle: `none`,
                padding: 0,
                marginTop: "1.75rem"
              }}
            >
              <li>
                {previous && (
                  <Link to={previous.fields.slug} rel="prev">
                    ← {previous.frontmatter.title}
                  </Link>
                )}
              </li>
              <li>
                {next && (
                  <Link to={next.fields.slug} rel="next">
                    {next.frontmatter.title} →
                  </Link>
                )}
              </li>
            </ul>
          </nav>
          }
        </div>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
      }
      fields {
        slug
      }
    }
  }
`
